import React, { useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UserProps from '../proptypes/user';
import { IDME_URL, RX_URL, SHOP_URL } from '../constants';
import { installNavLogo, NAV_LOGO } from '../fragno1/navLogo';
import useFragno1 from '../fragno1/useFragno1';

// Installed here, beside the app's only <idme-global-nav>.
installNavLogo();

const GlobalNav = ({ navLogo, user }) => {
  const { t } = useTranslation();
  const fragno1 = useFragno1();
  const globalNavRef = useRef(null);

  // Before paint, so the nav's first render already has the logo.
  useLayoutEffect(() => {
    const nav = globalNavRef.current;
    if (!nav) return;
    nav.navLogo = navLogo;
    nav.requestUpdate();
  }, [navLogo]);

  return (
    <idme-global-nav
      helpCenterHref="https://help.id.me"
      logoHref={IDME_URL}
      logoTitle={t('shared.idmeLogoAlt')}
      navTitle="Site"
      myAccountHref="/"
      myAccountText="My Wallet"
      logOutAuthenticityToken="form_authenticity_token,"
      isSignedIn
      logOutHref="/logout"
      logOutMethod="get"
      registerLinkHref="new_registration_path,"
      userEmail={user.email}
      userName={user.fname || ''}
      ref={globalNavRef}
    >
      <idme-nav-item
        href={`${SHOP_URL}?&utm_campaign=B2C&utm_source=nav_menu&utm_medium=web`}
        text="Shop"
      ></idme-nav-item>
      <idme-nav-item
        href={`${IDME_URL}/government?utm_campaign=B2C&utm_medium=web&utm_source=nav_menu`}
        text="Government"
      ></idme-nav-item>
      {/* The rebrand drops Rx and Jobs from the nav. */}
      {!fragno1 && (
        <idme-nav-item
          href={`${RX_URL}?&utm_campaign=B2C&utm_source=nav_menu&utm_medium=web`}
          text="Rx"
        ></idme-nav-item>
      )}
      {!fragno1 && (
        <idme-nav-item
          href={`${IDME_URL}/jobshub?utm_campaign=B2C&utm_medium=web&utm_source=nav_menu`}
          text="Jobs"
        ></idme-nav-item>
      )}
    </idme-global-nav>
  );
};

GlobalNav.propTypes = {
  navLogo: PropTypes.oneOf(Object.values(NAV_LOGO)),
  user: UserProps.isRequired,
};

GlobalNav.defaultProps = {
  navLogo: null,
};

export default GlobalNav;
